var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AngledContainer } from '../angledContainer/AngledContainer';
import card from '../../assets/images/twoCards/MaskGroup.png';
import { PrimaryButton } from '../buttons/PrimaryButton';
import parse from 'html-react-parser';
import './ResourceCard.scss';
var defaultProps = {
    id: 'card-0',
    image: card,
    type: 'white paper',
    title: 'The Intelligent Financial Life™',
    copy: 'Download the white paper that started it all. Bill Crager, Co-Founder and CEO of Envestnet, outlines why meeting consumer demand for an intelligently connected financial life is the future of our industry.',
    url: '/',
    ctaCopy: 'Read Now',
};
var angles = {
    topLeftInit: 0,
    topLeftEnd: 0,
    topRightInit: 100,
    topRightEnd: 0,
    bottomRightInit: 100,
    bottomRightEnd: 100,
    bottomLeftInit: 0,
    bottomLeftEnd: 89,
};
var heigths = 'h-[347px] md:h-[325px] lg:h-[401px]';
export var ResourceCard = function (_a) {
    var className = _a.className, image = _a.image, type = _a.type, title = _a.title, copy = _a.copy, url = _a.url, ctaCopy = _a.ctaCopy;
    return (_jsx("div", __assign({ className: "resource-card-outer-container" }, { children: _jsx("div", __assign({ className: "resource-card-container w-[327px] md:w-[284px] lg:w-[360px] " }, { children: _jsx("a", __assign({ href: url, target: "_blank", rel: "noreferrer" }, { children: _jsxs("div", __assign({ className: "resource-card resource-card-stroke resource-card-rounded w-[327px] pb-[31px] md:w-[284px] md:pb-[27px] lg:w-[360px] lg:pb-[40px] " + (className || '') }, { children: [_jsxs(AngledContainer, __assign({ className: "resource-card-rounded mb-3 box-content flex h-[348px] w-full bg-cover bg-center bg-no-repeat pt-[38px] md:h-[326px] md:pt-[35px] lg:pt-[57px] " + heigths, backgroundImage: "url(\"" + image + "\")" }, angles, { children: [_jsx("div", { className: "resource-card-overlay" }, void 0),
                                _jsxs("div", __assign({ className: "resource-card-text z-10 md:pr[30px] lg:pr[41px] box-content w-[271px] pl-[28px] pr-[28px] md:w-[236px] md:pl-[24px] lg:w-[279] lg:pl-[40px]" }, { children: [_jsx("p", __assign({ className: "resource-card-eyebrow mb-[5px] text-[12px] font-bold uppercase leading-[1.67]" }, { children: type }), void 0),
                                        _jsx("h3", __assign({ className: "resource-card-heading mb-[24px] text-[18px] font-bold leading-[1.33] md:text-[16px] lg:text-[20px] lg:mb-[25px]" }, { children: title }), void 0),
                                        _jsx("hr", { className: "mb-[24px] lg:mb-[26px]", style: { borderTop: 'solid 0.5px #d8dcdb' } }, void 0),
                                        copy && (_jsx("p", __assign({ className: "text-[14px] leading-[1.71]" }, { children: parse(copy) }), void 0))] }), void 0)] }), void 0),
                        _jsx(PrimaryButton, __assign({ className: "ml-6 h-[40px] md:ml-5 lg:ml-8 adjust-padding" }, { children: _jsx("span", { children: ctaCopy }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0) }), void 0));
};
ResourceCard.defaultProps = defaultProps;
